import { observer } from "mobx-react-lite"
import { StyledButton } from "./StyledButton"

interface FloatingButtonProps {
	onClick: () => void
	icon: React.ReactNode
}

export const FloatingButton = observer(({ icon, onClick }: FloatingButtonProps) => {
	return (
		<div className="fixed bottom-0 right-0 mb-[33px] mr-[27px] bg-transparent">
			<StyledButton style="bg-transparent" onClick={onClick}>
				{icon}
			</StyledButton>
		</div>
	)
})
